import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { Link } from 'react-router-dom'
import {
  avatar1,
  avatar13,
  avatar2,
  avatar3,
  avatar6,
  avatar7,
  avatar8,
  avatar9,
  userProfile,
} from '../../assets/images'
import {
  IconCamera,
  IconFileTypeDoc,
  IconPaperclip,
} from '@tabler/icons-react'

export default function ProjectDetail() {

  const twitterChat = [
    {
      image: avatar1,
      name: "Chris Fox",
      status: true,
      tagline: "Contrary to popular belief not simply text",
      lastSeen: "1 hours ago"
    },
    {
      image: avatar2,
      name: "Joge Lucky",
      status: false,
      tagline: "Contrary to popular belief not simply text",
      lastSeen: "2 hours ago"
    },
    {
      image: avatar3,
      name: "Isabella",
      status: true,
      tagline: "Contrary to popular belief not simply text",
      lastSeen: "1 day ago"
    },
  ]

  return (
    <>
      <Breadcrumb title="Project Detail" path="Projects / Project Detail" />
      <div className='grid lg:grid-cols-12 grid-cols-1 gap-30'>
        <div className='lg:col-span-4 flex flex-col gap-30'>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
            <p className='text-[16px]/[19.2px] font-medium mb-20'>
              iNext - One Page Responsive Template
            </p>
            <p className='mb-20'>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
            </p>
            <div>
              <p className='mb-1'>Project Setup</p>
              <div className='progress h-20 bg-bg-light-100 rounded-lg overflow-hidden'>
                <div className="progress-bar w-[78%] h-full bg-blue text-[12px]/[20px] text-white font-medium px-5 flex items-center justify-center">78%</div>
              </div>
            </div>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
            <ul className='flex flex-col gap-20'>
              <li className='flex items-center justify-between gap-10 flex-wrap'>
                <span>
                  Cost :
                </span>
                <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-primary text-white rounded'>
                  $16,785
                </span>
              </li>
              <li className='flex items-center justify-between gap-10 flex-wrap'>
                <span>
                  Created :
                </span>
                <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>
                  14 Mar, 2021
                </span>
              </li>
              <li className='flex items-center justify-between gap-10 flex-wrap'>
                <span>
                  Deadline :
                </span>
                <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-blue text-white rounded'>
                  22 Aug, 2021
                </span>
              </li>
              <li className='flex items-center justify-between gap-10 flex-wrap'>
                <span>
                  Priority :
                </span>
                <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-danger text-white rounded'>
                  Highest priority
                </span>
              </li>
              <li className='flex items-center justify-between gap-10 flex-wrap'>
                <span>
                  Status :
                </span>
                <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-warning text-white rounded'>
                  Working
                </span>
              </li>
            </ul>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
            <p className='text-[16px]/[19.2px] font-medium mb-20'>
              Assigned Team
            </p>
            <div className='flex items-center gap-15 pb-15 mb-15 border-b border-border'>
              <img src={avatar13} alt="Project Lead" width="90" height="90" className='w-[72px] h-[72px] rounded-full object-cover' />
              <div>
                <p className='text-[20px]/[24px] font-medium mb-1'>
                  Fidel Tonn
                </p>
                <p className='mb-1'>
                  info@thememakker.com
                </p>
                <p className='mb-1'>
                  Project Lead
                </p>
              </div>
            </div>
            <div className='flex flex-col gap-20'>
              {twitterChat.map((item, key) => (
                <div key={key} className='flex items-start justify-between gap-10 group cursor-pointer'>
                  <div className='flex items-center gap-10'>
                    <div className='relative'>
                      <img src={item.image} alt='profile' width="40" height="40" className='min-w-[40px] max-w-[40px] min-h-[40px] max-h-[40px] border-2 border-transparent object-cover rounded-full transition-all duration-300 ease-in-out group-hover:border-primary' />
                      <span className={`inline-block absolute bottom-0 right-0 w-[11px] h-[11px] rounded-full border-2 border-bg-light ${item.status ? 'bg-warning' : 'bg-success'}`}></span>
                    </div>
                    <div className='text-left'>
                      <p className='text-[15px]/[22.5px]'>
                        {item.name}
                      </p>
                      <p className='text-[13px]/[19.5px] text-text-secondary'>
                        {item.tagline}
                      </p>
                    </div>
                  </div>
                  <small className='text-right min-w-fit'>
                    {item.lastSeen}
                  </small>
                </div>
              ))}
            </div>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg border border-dashed border-primary'>
            <p className='text-[16px]/[19.2px] font-medium md:p-20 p-15 border-b border-dashed border-primary'>
              About Clients
            </p>
            <div className='flex flex-col items-center justify-center gap-15 md:p-20 p-15'>
              <img src={userProfile} alt="Project Lead" width="140" height="140" className='w-[140px] h-[140px] rounded-full object-cover' />
              <div className='text-[24px]/[28.8px] font-medium'>
                Jessica Doe
              </div>
              <div className='text-text-secondary'>
                Washington, d.c.
              </div>
              <div className='flex gap-5'>
                <button className='btn btn-primary'>
                  Profile
                </button>
                <button className='btn btn-outline-secondary'>
                  Message
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='lg:col-span-8 flex flex-col gap-30'>
          <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
            <div className='text-[16px]/[19.2px] font-medium mb-30'>
              Project Activity
            </div>
            <div className='form-group flex mb-20'>
              <textarea rows={4} placeholder='Please type what you want...' />
            </div>
            <div className='flex items-center gap-10'>
              <button className='btn btn-yellow'>
                <IconPaperclip className='w-[20px] h-[20px] stroke-[1.5]' />
              </button>
              <button className='btn btn-yellow'>
                <IconCamera className='w-[20px] h-[20px] stroke-[1.5]' />
              </button>
              <button className='btn btn-blue'>
                Add
              </button>
            </div>
          </div>
          <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
            <div className='p-20 border-l border-success relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-success after:rounded-full'>
              <p className='text-success mb-10'>
                Just Now
              </p>
              <p className='text-[16px]/[19.2px] font-medium mb-10'>
                iNext - One Page Responsive Template
              </p>
              <p>
                Project Lead : <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>Fidel Tonn</Link>
              </p>
            </div>
            <div className='p-20 border-l border-warning relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-warning after:rounded-full'>
              <p className='text-warning mb-10'>
                02 Jun 2021
              </p>
              <p className='text-[16px]/[19.2px] font-medium mb-10'>
                Add Team Members
              </p>
              <p className='mb-15'>
                By : <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>Fidel Tonn</Link>
              </p>
              <p className='mb-15'>
                web by far While that's mock-ups and this is politics, are they really so different? I think the only card she has is the Lorem card.
              </p>
              <ul className="flex items-center mb-15">
                <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li title='Chris Fox' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              </ul>
              <div className='flex gap-15 items-center'>
                <Link to="#" className='border border-border rounded-lg flex items-center justify-center p-10 transition-all duration-300 hover:bg-bg-light-100'>
                  <IconFileTypeDoc />
                </Link>
                <div className='flex flex-col gap-5'>
                  <p>
                    iNext project documentation.doc
                  </p>
                  <p>
                    Size : 2.3MB
                  </p>
                </div>
              </div>
            </div>
            <div className='p-20 border-l border-warning relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-warning after:rounded-full'>
              <p className='text-warning mb-10'>
                02 Jun 2021
              </p>
              <p className='text-[16px]/[19.2px] font-medium mb-10'>
                Task Assigned
              </p>
              <p className='mb-15'>
                By : <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>Fidel Tonn</Link>
              </p>
              <p className='mb-15'>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal
              </p>
              <div className='flex flex-col gap-15'>
                <div className='flex gap-10'>
                  <img src={avatar1} alt='avatar' width="45" height="45" className='w-[45px] h-[45px] rounded-lg object-cover' />
                  <div className='flex flex-col gap-5'>
                    <p>
                      Folisise Chosielie
                    </p>
                    <p>
                      <b>Detail : </b> Ipsum is simply dummy text of the printing and typesetting industry.
                    </p>
                  </div>
                </div>
                <div className='flex gap-10'>
                  <img src={avatar2} alt='avatar' width="45" height="45" className='w-[45px] h-[45px] rounded-lg object-cover' />
                  <div className='flex flex-col gap-5'>
                    <p>
                      Joge Lucky
                    </p>
                    <p>
                      <b>Detail : </b> Ipsum is simply dummy text of the printing and typesetting industry.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='p-20 border-l border-warning relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-warning after:rounded-full'>
              <p className='text-warning mb-10'>
                02 Jun 2021
              </p>
              <p className='text-[16px]/[19.2px] font-medium mb-10'>
                Add new code on GitHub
              </p>
              <p className='mb-15'>
                By : <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>Folisise Chosielie</Link>
              </p>
              <p className='md:p-20 p-15 text-black border border-success rounded-lg bg-success-50 mb-15'>
                Code Update Successfully in GitHub
              </p>
              <div className='md:p-20 p-15 bg-bg-light-100 text-[12px] tracking-[1px]'>
                <p>
                  <span className='text-blue'>{'<button'}</span> <span className="text-sky">{'class='}</span><span className='text-success'>{'"btn btn-primary"'}</span><span className='text-blue'>{'>'}</span>{'Primary'}<span className='text-blue'>{'</button>'}</span>
                </p>
                <p>
                  <span className='text-blue'>{'<button'}</span> <span className="text-sky">{'class='}</span><span className='text-success'>{'"btn btn-secondary"'}</span><span className='text-blue'>{'>'}</span>{'Secondary'}<span className='text-blue'>{'</button>'}</span>
                </p>
                <p>
                  <span className='text-blue'>{'<button'}</span> <span className="text-sky">{'class='}</span><span className='text-success'>{'"btn btn-blue"'}</span><span className='text-blue'>{'>'}</span>{'Blue'}<span className='text-blue'>{'</button>'}</span>
                </p>
                <p>
                  <span className='text-blue'>{'<button'}</span> <span className="text-sky">{'class='}</span><span className='text-success'>{'"btn btn-danger"'}</span><span className='text-blue'>{'>'}</span>{'Red'}<span className='text-blue'>{'</button>'}</span>
                </p>
                <p>
                  <span className='text-blue'>{'<button'}</span> <span className="text-sky">{'class='}</span><span className='text-success'>{'"btn btn-yellow"'}</span><span className='text-blue'>{'>'}</span>{'Yellow'}<span className='text-blue'>{'</button>'}</span>
                </p>
              </div>
            </div>
            <div className='p-20 border-l border-danger relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-danger after:rounded-full'>
              <p className='text-danger mb-10'>
                04 Jun 2021
              </p>
              <p className='text-[16px]/[19.2px] font-medium mb-10'>
                Project Reports
              </p>
              <p className='mb-15'>
                By : <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>Fidel Tonn</Link>
              </p>
              <div className='flex flex-col gap-15'>
                <p>
                  <p className='mb-[2px]'>
                    Design Bug
                  </p>
                  <div className='progress h-5 bg-bg-light-100 rounded-lg overflow-hidden'>
                    <div className="progress-bar w-[17%] h-full bg-danger text-[12px]/[20px] text-white font-medium px-5 flex items-center justify-center"></div>
                  </div>
                </p>
                <p>
                  <p className='mb-[2px]'>
                    UI/UX Design Task
                  </p>
                  <div className='progress h-5 bg-bg-light-100 rounded-lg overflow-hidden'>
                    <div className="progress-bar w-[83%] h-full bg-blue text-[12px]/[20px] text-white font-medium px-5 flex items-center justify-center"></div>
                  </div>
                </p>
                <p>
                  <p className='mb-[2px]'>
                    Developer Task
                  </p>
                  <div className='progress h-5 bg-bg-light-100 rounded-lg overflow-hidden'>
                    <div className="progress-bar w-[49%] h-full bg-success text-[12px]/[20px] text-white font-medium px-5 flex items-center justify-center"></div>
                  </div>
                </p>
                <p>
                  <p className='mb-[2px]'>
                    QA (Quality Assurance)
                  </p>
                  <div className='progress h-5 bg-bg-light-100 rounded-lg overflow-hidden'>
                    <div className="progress-bar w-[33%] h-full bg-yellow text-[12px]/[20px] text-white font-medium px-5 flex items-center justify-center"></div>
                  </div>
                </p>
              </div>
            </div>
            <div className='p-20 border-l border-text-primary relative after:contents-[""] after:absolute after:top-[1.3rem] after:left-[-6px] after:w-10 after:h-15 after:bg-bg-dark after:border-2 after:border-text-primary after:rounded-full'>
              <p className='text-text-primary mb-10'>
                05 Jun 2021
              </p>
              <p className='text-[16px]/[19.2px] font-medium'>
                Project on Goinng
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
